import { Link } from "react-router-dom";
import { motion } from "framer-motion";
import { Camera, GridFour, ClockCounterClockwise, GraduationCap, ArrowRight } from "@phosphor-icons/react";
import { useTranslation } from "@/contexts/LanguageContext";

const LESSONS = [
  { to: "/anatomy", titleKey: "nav_anatomy", descKey: "found_anatomy_desc", Icon: Camera, color: "#60A5FA", testId: "foundations-anatomy" },
  { to: "/bayer-filter", titleKey: "nav_bayer", descKey: "found_bayer_desc", Icon: GridFour, color: "#34D399", testId: "foundations-bayer" },
  { to: "/camera-history", titleKey: "nav_camera_history", descKey: "found_history_desc", Icon: ClockCounterClockwise, color: "#F5A524", testId: "foundations-history" },
];

export default function FoundationsCard() {
  const { t } = useTranslation();
  return (
    <motion.div
      initial={{ opacity: 0, y: 16 }}
      whileInView={{ opacity: 1, y: 0 }}
      viewport={{ once: true }}
      transition={{ duration: 0.4 }}
      className="bg-[#121214]/80 backdrop-blur-md border border-white/10 rounded-xl p-6"
      data-testid="foundations-card"
    >
      <div className="flex items-center gap-2 mb-1">
        <span className="inline-flex items-center gap-1.5 px-2.5 py-1 rounded-full bg-[#F5A524]/15 border border-[#F5A524]/30 text-[#F5A524] text-xs font-semibold uppercase tracking-[0.15em]">
          <GraduationCap weight="fill" className="w-3.5 h-3.5" />
          {t("found_badge")}
        </span>
      </div>
      <h2 className="font-['Outfit'] text-white text-xl font-semibold mb-1">{t("found_title")}</h2>
      <p className="text-[#71717A] text-sm mb-5 max-w-2xl">{t("found_sub")}</p>

      <div className="grid grid-cols-1 sm:grid-cols-3 gap-3">
        {LESSONS.map((l, i) => (
          <Link
            key={l.to}
            to={l.to}
            className="group relative flex flex-col gap-2 p-4 rounded-xl bg-[#0A0A0A] border border-white/10 hover:border-white/25 transition-all duration-200 hover:-translate-y-0.5"
            data-testid={l.testId}
          >
            <div className="flex items-center justify-between">
              <span
                className="w-9 h-9 rounded-lg flex items-center justify-center"
                style={{ backgroundColor: `${l.color}1A` }}
              >
                <l.Icon weight="fill" className="w-5 h-5" style={{ color: l.color }} />
              </span>
              <span className="font-['JetBrains_Mono'] text-xs text-[#52525B]">0{i + 1}</span>
            </div>
            <div>
              <h3 className="text-white font-medium text-sm flex items-center gap-1">
                {t(l.titleKey)}
                <ArrowRight weight="bold" className="w-3.5 h-3.5 text-[#52525B] group-hover:text-[#F5A524] group-hover:translate-x-0.5 transition-all" />
              </h3>
              <p className="text-[#71717A] text-xs mt-0.5 leading-relaxed">{t(l.descKey)}</p>
            </div>
          </Link>
        ))}
      </div>
    </motion.div>
  );
}
